.root {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  font-family: -apple-system, BlinkMacSystemFont,
    var(--dixa-typography-family-default);
  line-height: 1;

  &.rich {
    $min-size: 32px;
    min-width: $min-size;
    min-height: $min-size;
    border: var(--dixa-size-border-100) solid var(--dixa-color-neutral-500);
    border-radius: var(--dixa-size-border-radius-100);
    box-shadow: 0 1px 1px var(--dixa-color-neutral-500),
      0 2px 0 0 var(--dixa-color-neutral-000) inset;
    color: var(--dixa-color-neutral-700);
    background-color: var(--dixa-color-neutral-100);
    text-shadow: 0 1px 1px var(--dixa-color-neutral-000);
    font-size: var(--dixa-typography-size-300);
    font-weight: var(--dixa-typography-weight-semibold);
    padding: 0 var(--dixa-size-spacer-200);
  }

  &.simple {
    min-width: 22px;
    min-height: 20px;
    border: 0;
    border-radius: var(--dixa-size-border-radius-100);
    box-shadow: none;
    color: inherit;
    background-color: transparent;
    font-size: var(--dixa-typography-size-200);
    font-weight: var(--dixa-typography-weight-normal);
    padding: 0 var(--dixa-size-spacer-100);
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: currentColor;
      opacity: 0.2;
    }
  }
}
